<script lang="ts" setup>
  import { HoverCard, HoverCardContent, HoverCardTrigger } from '~/components/ui/hover-card'
  import { PowerIcon, UserCircle, UserCircleGear } from '~/components/icons'
  import Divider from '../ui/Divider/Divider.vue'
  import LangSwitcher from '~/components/nav/LangSwitcher.vue'
  import { useAuthentication } from '~/composables/auth/useAuthentication'
  import { useOAuth } from '~/composables/auth/useOAuth'

  const authStore = useAuthStore()
  const { user, activeLicence } = storeToRefs(authStore)
  const oauth = useOAuth()
  const { logUserOut } = useAuthentication()

  const openLicenceSelector = (): void => {
    authStore.clearActiveLicence()
  }

  const handleLogout = (): void => {
    logUserOut()
    navigateTo(oauth.buildRedirectUrl('logout'), { external: true })
  }
</script>

<template>
  <div class="text-white w-full flex justify-center">
    <HoverCard>
      <HoverCardTrigger>
        <div class="relative p-2 rounded-md overflow-hidden cursor-pointer">
          <div class="text-white w-full">
            <UserCircleGear class="size-5" />
          </div>
        </div>
      </HoverCardTrigger>
      <HoverCardContent align="end" class="bg-white p-2 rounded-md flex flex-col gap-1" side="right" :side-offset="2">
        <div class="flex gap-2 items-center p-1">
          <UserCircle class="w-6 h-6" />
          <div class="flex flex-col items-start w-full">
            <div class="flex justify-between w-full items-center">
              <p class="text-xs+">{{ activeLicence?.name || '-' }}</p>
              <p class="text-tiny text-muted-foreground text-right">{{ 'v 1.2.0' }}</p>
            </div>
            <p class="text-tiny text-muted-foreground">{{ user?.name }}</p>
          </div>
        </div>
        <Divider />
        <div class="flex flex-col gap-0.5">
          <LangSwitcher class="p-2 rounded-md" />
          <div class="flex justify-between gap-8 items-center p-2">
            <p class="text-content-title font-semibold text-sm">{{ $t('licences.currentLicence') }}</p>
            <Button class="p-1 min-w-32" variant="secondary" :title="activeLicence?.name" @click="openLicenceSelector">
              <p class="font-semibold text-content-title text-sm px-2 truncate">
                {{ activeLicence?.name || '-' }}
              </p>
            </Button>
          </div>
        </div>
        <Divider />
        <Button class="w-full bg-red-500/10" variant="destructive" @click="handleLogout">
          <PowerIcon />
          {{ $t('common.signOut') }}
        </Button>
      </HoverCardContent>
    </HoverCard>
  </div>
</template>

<style scoped></style>
